"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppComponent = void 0;
//ANGULAR2 BITS
const router_1 = require("@angular/router");
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const ng2_dragula_1 = require("ng2-dragula");
const ng2_daterangepicker_1 = require("ng2-daterangepicker");
//INTERNAL LIBRARY BITS
const version_service_1 = require("./version.service");
const loading_service_1 = require("./loading.service");
const notifier_service_1 = require("./notifier.service");
const system_notification_service_1 = require("./system-notification.service");
(0, core_1.enableProdMode)(); //required function for angular 2 right now
let AppComponent = class AppComponent {
    constructor(_router, _v, _dAD, _loading, daterangepickerOptions, _notifier, 
    //LIA Notifications check will be auto started on constructor instantiation
    _systemNotifcations) {
        this._router = _router;
        this._v = _v;
        this._dAD = _dAD;
        this._loading = _loading;
        this.daterangepickerOptions = daterangepickerOptions;
        this._notifier = _notifier;
        this._systemNotifcations = _systemNotifcations;
        this.title = 'Control Center';
        this.daterangepickerOptions.skipCSS = true;
        _router.events.subscribe((val) => {
            if (val instanceof router_1.NavigationEnd) {
                let newRoute = val.url || '/';
                if (this.currentRoute != newRoute) {
                    ga('set', 'page', newRoute); //google analytics
                    ga('send', 'pageview'); //google analytics
                    this.currentRoute = newRoute;
                }
            }
        });
        this._dAD.setOptions('ad-bag', {
            moves: function (el, container, handle) {
                return handle.className === 'handle';
            }
        });
    }
};
exports.AppComponent = AppComponent;
exports.AppComponent = AppComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-app',
        templateUrl: 'app/app.component.html',
        styleUrls: ['styles/app.component.css']
    }),
    __metadata("design:paramtypes", [router_1.Router,
        version_service_1.VersionService,
        ng2_dragula_1.DragulaService,
        loading_service_1.LoadingService,
        ng2_daterangepicker_1.DaterangepickerConfig,
        notifier_service_1.NotifierService,
        system_notification_service_1.SystemNotificationService])
], AppComponent);
//# sourceMappingURL=app.component.js.map